import { and } from 'tio-ui/utilities';
import { array, hash } from '@ember/helper';
import { Header, HStack, VStack } from 'tio-ui/components/layout';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import ApplicationHistory from 'tio-common/components/tas/application-history';
import ClaimsFinancialsCalculationsReadonlyCard from 'tio-common/components/tuition-assistance/program-details/claims-financials/calculations-readonly-card';
import NavTabs from 'tio-ui/components/nav-tabs';
import PaymentDetailsCard from 'tio-common/components/tas/payment-details-card';
import type { TOC } from '@ember/component/template-only';
import type TasApplicationModel from 'tio-data/models/tas-application';
import { PhCaretLeft } from 'ember-phosphor-icons';

interface TasApplicationHistorySignature {
  Args: {
    model: TasApplicationModel;
  };
}

const tmpl: TOC<TasApplicationHistorySignature> = <template>
  <VStack>
    <Header>
      <div>
        {{! TAS.TODO: temporary routing until tas dashboard is complete }}
        <LinkTo class="flex justify-left items-center gap-4" @route="authenticated.tas.dashboard">
          <PhCaretLeft @size="20" class="inline" />
          {{t "tas.default"}}
        </LinkTo>
      </div>
    </Header>
    <NavTabs
      class="mb-4"
      @tabs={{array
        (hash
          label=(t "tas.applications.default")
          route="authenticated.tas.applications.show"
          model=@model.id
        )
        (hash
          label=(t "tas.history.default")
          route="authenticated.tas.applications.history"
          model=@model
        )
      }}
    />
    <HStack>
      <ApplicationHistory
        @history={{@model.fullHistory}}
        @title={{@model.applicationName}}
        @application={{@model}}
      />
      <VStack class="md:w-1/3">
        <PaymentDetailsCard
          @showDetails={{and @model.shouldDisplayPaymentDetails @model.paymentsHistory.length}}
          @requestedTotal={{@model.requestedTotal}}
          @payments={{@model.paymentsHistory}}
          @isCreditBased={{@model.isCreditBased}}
          @totalCredits={{@model.totalCredits}}
        />
        <ClaimsFinancialsCalculationsReadonlyCard
          class="grow md:max-w-xl"
          @claimsFinancialsFields={{@model.claimsFinancialsCalculatorInput}}
          @showDetails={{@model.tasProgramInstance.tasProgramTemplate.calculateTotalByClaimsFinancials}}
        />
      </VStack>
    </HStack>
  </VStack>
</template>;

export default tmpl;
